import types from '../../config/types.js'
import MockServer from './MockServer.js'
import MockPagination from './MockPagination.js'
import ServiceData from 'Mixins/ServiceData.js'

export default {
  mixins: [MockServer, ServiceData, MockPagination],
  data() {
    return {
      searchTimeOut: null,
      filtersData: {},
    }
  },
  computed: {
    filters() {
      return [
        {
          id: 'search',
          type: types.components.input,
          width: 5,
          attr: {
            placeholder: 'Поиск',
          },
        },
        {
          id: 'property_ids',
          type: types.components.select,
          width: 4,
          attr: {
            placeholder: 'Все адреса',
            options: this.meterConfigPropertyListOptions,
          },
        },
        {
          id: 'enviro_server_ids',
          type: types.components.select,
          width: 3,
          attr: {
            placeholder: 'Все серверы',
            options: this.serverListOptions,
          },
        },
      ]
    },
    tableColumns() {
      return [
        {
          id: 'address',
          label: 'Адрес',
          onclick: () => {
            this.filtersData.order = 'address'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredMeterConfigs()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'address',
        },
        {
          id: 'server',
          label: 'Сервер',
          onclick: () => {
            this.filtersData.order = 'host'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredMeterConfigs()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'host',
        },
        {
          id: 'subs',
          label: 'Количество квартир',
          onclick: () => {
            this.filtersData.order = 'unit_count'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredMeterConfigs()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'unit_count',
        },
        {
          id: 'tariff_type',
          component: {
            type: 'switcher',
            'label-true': 'Суммарно',
            'label-false': 'День/Ночь',
          },
          label: 'Схема учета',
          onclick: () => {},
          clickable: false,
          selected: this.filtersData.order === 'tariff_type',
        },
      ]
    },
    tableRows() {
      const data = []

      this.meterConfigList.forEach(meterConfig => {
        data.push({
          id: meterConfig.id,
          columns: [
            {
              id: 'address',
              content: {
                id: meterConfig.id,
                label: meterConfig.property.address,
              },
            },
            {
              id: 'server',
              content: {
                id: meterConfig.id,
                label: meterConfig.server.host ?? '-',
              },
            },
            {
              id: 'subs',
              content: {
                id: meterConfig.id,
                label: meterConfig.meter_config_units_count,
              },
            },
            {
              id: 'tariff_type',
              content: {
                id: meterConfig.id,
                label: meterConfig.tariff_type === 2 ? true : false,
              },
            },
          ],
        })
      })

      return data
    },
    actions() {
      return {
        default: [
          {
            id: 3,
            type: types.actions.button,
            attr: {
              type: 'primary',
              label: 'Подключить адрес',
              icon: 'plus-outlined',
              handler: () => this.$router.push({ name: 'AddMeterConfig' }),
            },
          },
          {
            id: 2,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              label: 'Добавить сервер',
              icon: 'plus-outlined',
              handler: () => this.$emit('addServer'),
            },
          },
        ],

        selected: [
          {
            id: 1,
            type: types.actions.text,
            label: `Выбрано элементов: ${this.rowsSelected.length}`,
          },
          {
            id: 2,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              label: 'Отменить выделение',
              icon: 'cross',
              handler: () => (this.rowsSelected = []),
            },
          },
          {
            id: 3,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              colored: 'danger',
              label: 'Удалить телеметрию',
              icon: 'trash',
              handler: () => this.openDeleteModal(),
            },
          },
        ],
      }
    },
  },
  methods: {
    toggleColumnOrderType(column) {
      this.filtersData.order_type =
        this.filtersData.order === column &&
        this.filtersData.order_type === 'asc'
          ? 'desc'
          : 'asc'
    },
    onRowClick(rowId) {
      this.$router.push({ name: 'Address', params: { meterConfigId: rowId } })
    },

    onSwitcherClick({ row, column, currentValue }) {
      if (column === 'tariff_type') {
        this.updateTariffType(row, currentValue)
      }
    },

    updateTariffType(meterConfig, currentValue) {
      this.$store.dispatch('setIsLoadingData', true)

      this.updateTariffTypes({
        id: meterConfig,
        tariff_type: currentValue ? 1 : 2,
      })
        .then(response => {
          this.$store.dispatch('setMeterConfigTariffType', {
            id: meterConfig,
            tariff_type: currentValue ? 1 : 2,
          })

          this.$store.dispatch('setIsLoadingData', false)
          // this.getFilteredMeterConfigs()
        })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('setIsLoadingData', false)
        })
    },
    filterMeterConfig(filters) {
      this.filtersData = filters

      if (this.searchTimeOut) {
        clearTimeout(this.searchTimeOut)
      }

      this.searchTimeOut = setTimeout(() => {
        this.getFilteredMeterConfigs()
      }, 2000)
    },
    setMeterConfigsPagination() {
      this.initPagination(
        this.meterConfigsMeta.current_page,
        this.meterConfigsMeta.total,
        this.meterConfigsMeta.per_page
      )
    },
    onSwitchPage(page) {
      this.filtersData.page = page
      this.getFilteredMeterConfigs()
    },
    getFilteredMeterConfigs() {
      this.filtersData.organizationId = this.currentOrganizationId
      this.getMeterConfigs(this.filtersData)
      this.setMeterConfigsPagination()
    },
    removeMeterConfigs() {
      this.$store.dispatch('setIsLoading', true)
      this.meterConfigService
        .removeMeterConfigs(this.rowsSelected)
        .then(response => {
          this.$store.dispatch('setNotification', {
            text: 'Телеметрии успешно удалены.',
          })
          this.getFilteredMeterConfigs()
          this.rowsSelected = []
          this.$store.dispatch('setIsLoading', false)
        })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('setIsLoading', false)
        })
    },
  },
  mounted() {
    this.getServers({
      organizationId: this.currentOrganizationId,
    })

    this.getProperties({ organizationId: this.currentOrganizationId })

    // if (this.meterConfigList.length === 0) {
    this.getMeterConfigs({ organizationId: this.currentOrganizationId })
    // }

    this.setMeterConfigsPagination()
  },
}
